import React from "react";
import { AutoComplete, Input } from "antd";
import { Field, ErrorMessage } from "formik";
import TextError from "./TextError";

function AutoCompleteField({ label, name, placeholder, options = [], ...rest }) {
  return (
    <div className="mb-1">
      <div className="mb-1">
        <label htmlFor={name}>{label}</label>
      </div>
      <Field name={name}>
        {({ field, form }) => {
          const hasError = form.touched[name] && form.errors[name];
          return (
            <AutoComplete
              id={name}
              value={field.value}
              options={options}
              style={{ width: "100%" }}
              filterOption={(inputValue, option) =>
                option.value.toLowerCase().includes(inputValue.toLowerCase())
              }
              onChange={(value) => form.setFieldValue(name, value)}
              onBlur={() => form.setFieldTouched(name, true)}
              {...rest}
            >
              <Input
                placeholder={placeholder}
                status={hasError ? "error" : ""}
              />
            </AutoComplete>
          );
        }}
      </Field>
      <ErrorMessage component={TextError} name={name} />
    </div>
  );
}

export default AutoCompleteField;
